<script>
import Banner from '../../components/banner'
export default {
    name: "study",
    data() {
        return {};
    },
    computed: {},
    components: {
        Banner
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="study">
        <Banner position="right bottom" :image="require('@/assets/images/study_banner.jpg')" :title="`Our Courses`" :desc="`Find the degree or diploma program that suits your needs, your budget\r\nand your career goals.`"/>
        <router-view></router-view>
    </div>
</template>

<style scoped lang="scss">
.study{
    
}
</style>